import { NotificationsPage } from "./center";

export const pages = {
  notifications: NotificationsPage,
};
